import CustomerProject from "../../../classes/CustomerProject.js";
import CustomerProjectItem from "../../../classes/CustomerProjectItem.js";
import CustomerServiceIssue from "../../../classes/CustomerServiceIssue.js";
import { customerScope } from "../../../util/customerScope.js";

// The customer copies functions/customerMirrors.js keeps under
// c/{customerID}. Customers cannot read the raw projects and service issues
// (firestore.rules), so every customer view reads these instead.

// Like LISTEN_CUSTOMER_QUOTES, these fan out across the customer's companies
// and resolve to an ARRAY of { path, listenerId } handles to UNLISTEN.
const listenAcross = (dispatch, state, converter, stateKey, options) => {
  const { customerID, next, error, unlisten, retain } = options;
  return Promise.all(
    customerScope(state, customerID).map((id) =>
      dispatch("LISTEN_COLLECTION", {
        converter,
        path: converter.getPath(id),
        stateKey,
        next,
        error,
        unlisten,
        retain,
      })
    )
  );
};

export const LISTEN_CUSTOMER_PROJECTS = async ({ dispatch, state }, options) =>
  listenAcross(dispatch, state, CustomerProject, "customerProjects", options);

export const LISTEN_CUSTOMER_PROJECT = async (
  { dispatch },
  { customerID, projectID, next, error }
) =>
  dispatch("LISTEN_DOC", {
    converter: CustomerProject,
    path: CustomerProject.getPath(customerID, projectID),
    stateKey: "customerProjects",
    id: projectID,
    next,
    error,
  });

export const LISTEN_CUSTOMER_PROJECT_ITEMS = async (
  { dispatch },
  { customerID, projectID, next, error }
) =>
  dispatch("LISTEN_COLLECTION", {
    converter: CustomerProjectItem,
    path: CustomerProjectItem.getPath(customerID, projectID),
    stateKey: "customerProjectItems",
    next,
    error,
  });

export const LISTEN_CUSTOMER_SERVICE_ISSUES = async (
  { dispatch, state },
  options
) =>
  listenAcross(
    dispatch,
    state,
    CustomerServiceIssue,
    "customerServiceIssues",
    options
  );

export const LISTEN_CUSTOMER_SERVICE_ISSUE = async (
  { dispatch },
  { customerID, issueID, next, error }
) =>
  dispatch("LISTEN_DOC", {
    converter: CustomerServiceIssue,
    path: CustomerServiceIssue.getPath(customerID, issueID),
    stateKey: "customerServiceIssues",
    id: issueID,
    next,
    error,
  });
